<template>
  <div id="upload-page" class="mb-5">
    <div class="flex-grow my-8 px-3">
      <h1>{{ $t('UploadFirmOrders') }}</h1>
    </div>
    <vs-row>
      <vs-col>
        <div class="vx-card p-0">
          <firm-order-form />
        </div>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <portal-target name="form-buttons"/>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import FirmOrderForm from "./FirmOrderForm";

export default {
  components: {
    FirmOrderForm,
  },
  data() {
    return {

    }
  }

}
</script>
